import { get, isEmpty, isNil } from 'lodash';
import { requestUtils } from 'helpers/saga-helpers';
import userToken from 'containers/services/security/access-token-storage';

export const openDocument = (url: string) => () => window.open(url);
export const getLiveDocumentViewUrl = (
  path: string,
  filename: string,
  isIndexed: boolean,
  documentId: string,
) => {
  const baseApiPath = requestUtils.getApiBasePath();
  const accessToken = get(userToken.get(), 'token');
  if (isIndexed) {
    return `${baseApiPath}/corporeal/view-document?isIndexed=${isIndexed}&documentId=${documentId}&sagisToken=${accessToken}`;
  } else {
    return `${baseApiPath}/corporeal/view-document?filePath=${path}&fileName=${filename}&sagisToken=${accessToken}`;
  }
};
export const formatDocument = (claim: any) => {
  if (
    !isEmpty(get(claim, 'sagis.claims[0].ListDocsNotIndexed', [])) ||
    !isEmpty(get(claim, 'sagis.claims[0].ListDocsIndexed', []))
  ) {
    return [
      ...(isNil(get(claim, 'sagis.claims[0].ListDocsNotIndexed', []))
        ? []
        : get(claim, 'sagis.claims[0].ListDocsNotIndexed', [])
      ).map(
        (document: {
          type: string;
          name: string;
          fileName: string;
          path: string;
        }) => ({
          isIndexed: false,
          ...document,
        }),
      ),
      ...(isNil(get(claim, 'sagis.claims[0].ListDocsIndexed', []))
        ? []
        : get(claim, 'sagis.claims[0].ListDocsIndexed', [])
      ).map(
        (document: {
          DocumentID: string;
          DocumentType: string;
          fileName: string;
          path: string;
          dateCreation: string;
        }) => ({
          isIndexed: true,
          documentId: document.DocumentID,
          type: document.DocumentType,
          fileName: document.fileName,
          path: document.path,
          dateDeCreation: document.dateCreation,
        }),
      ),
    ];
  } else {
    return [];
  }
};

export const toDataUrl = async (url: any) => {
  const data = await fetch(url);
  const blob = await data.blob();
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    resolve(blob);
    reader.onerror = reject;
  });
};
/* istanbul ignore next */
export const blobtoDataUrl = async (blob: any) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    resolve(blob);
    reader.onerror = reject;
  });
};
